import CommonButton from './CommonButton';

export default CommonButton;
